import { useEffect, useRef, useState } from 'react';

import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import { ILink } from 'detailsv2/LandingV2/TableOfContents/types';
import { ELandingHeaderLayout } from 'detailsv2/LandingV2/types';

export const useVerticalAutoScroll = (activePageId: number, links: ILink[]) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const navRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const index = links.findIndex((link) => link.id === activePageId);
    setActiveIndex(index);
  }, [activePageId, links]);

  useEffect(() => {
    const navigation = navRef.current;
    const activeLink = navigation?.children[activeIndex] as HTMLDivElement;
    const navigationHeight = navigation?.offsetHeight;
    const activeLinkHeight = activeLink?.offsetHeight;
    const activeLinkTop = activeLink?.offsetTop;
    const scroll = activeLinkTop ? activeLinkTop - (navigationHeight || 0) / 2 + (activeLinkHeight || 0) / 2 : 0;
    navigation?.scrollTo({ top: scroll, behavior: 'smooth' });
  }, [activeIndex, navRef]);

  return { navRef };
};

export const useNavigationHeight = (config: ELandingHeaderLayout) => {
  const { landingRef, deviceType } = useLandingV2Context();
  const subTractor = config === ELandingHeaderLayout.FullWidth ? 109 : 88;
  const navigationContainerHeight =
    landingRef.current?.getBoundingClientRect().height! - (deviceType === 'mobile' ? 67 : subTractor) || 'auto';

  return { navigationContainerHeight };
};
